// Template Config

export default {
  name: "TEMPLATE",
  disabled_features: {
    // Core features
    email: false, // Whether to DISABLE the Email Channel in the campaign configuration flow
    sms: false, // Whether to DISABLE the SMS Channel in the campaign configuration flow
    voice: false, // Whether to DISABLE the Voice Channel in the campaign configuration flow
    qa_header: false, // Whether to DISABLE the orange banner/QA label in QA environment
    user_management: false, // Whether to DISABLE the user management section
  },
  enabled_features: {
    // Optional features
    campaign_templates: false, // Whether to ENABLE the templates feature for the client
    customer_preference_dip: false, // Whether to ENABLE campaigns to check a customer preference table before loading a dataset
    dataset_dip: false, // Whether to ENABLE client to "dip" datasets to find mobile phone numbers
    dataset_import: false, // Whether to ENABLE the presence of the "Data Summary" and "Create Dataset" Pages
    division_selection: false, // Whether to ENABLE the presence of the "Division" selection in the create campaign flow
    emergency_campaign_priority: false, // Whether to ENABLE campaigns to allow emergency priority toggle
    inbound_message: false, // Whether to ENABLE client to update a voice CID's inbound message
    push_notification_channel: false, // Whether to ENABLE push notification configuration in create campaign flow
    sso_microsoft: false, // Whether Login page should display the Microsoft SSO button
    voice_tts_dmf_enabled: false,
    offline_approval: false,
  },
  custom_labels: {
    /* "dataset.tableName": "Custom Label" */
  },
  sms: {
    short_codes: [
      { label: "12345 (Label)", value: "12345" }, // Sample
    ],
  },
  voice: {
    premium_options: [], // "all" || "premium" | "french" | "german" | "spanish"
    caller_id_options: [
      { label: "Select a phone number", isDisabled: true },
      { label: "(234) 567-8901 Sample", value: "2345678901" },
    ],
  },
};
